import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";
import { SignalRState } from "./state/signal-r.state";

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([SignalRState])]
})
export class SignalRServiceModule {}
